import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { removeTextUnderlineOnHover } from '@/theme';

export const HeaderWrapper = styled(Flex)`
  flex-direction: column;

  ${({ theme }) => css`
    background: ${theme.colors.secondaryLightGrey};
    padding: ${theme.spacing(2.5, 0, 4.5)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(2.5, 0, 4.5)};
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const LogoutButton = styled(Box)`
  ${removeTextUnderlineOnHover};
`;
